import React from 'react';

function PreApproveBrands() {
  return (
    <div>
      <p style={{ padding: "20px" }}>We are a leading company in tech world.</p>
    </div>
  );
}

export default PreApproveBrands;